import api from "@/app/api";
import Guid from "@/app/types/common/guid";
import { Instant, LocalDate, LocalTime } from "@js-joda/core";
import {ModelObject, BaseModelObject, ValidationRule} from "@/app/services/modelObject";
import ServiceBase from "@/app/services/serviceBase";
import converters from "@/app/services/converters"
import { EnumFileType } from "./enums/enumFileType.generated";

// Model Objects

export class FileBase64 extends ModelObject<FileBase64> {

    public id: Guid = Guid.createEmpty();
    /**
    * The original name of the file
    * Not Nullable
    * Not Empty
    * Max Length : 1000
    */
    public fileName: string = "";
    /**
    * The type of file.
    */
    public fileType: EnumFileType = EnumFileType.image;
    public fileContentsBase64: string = "";

    public constructor(jsonSerializedObject?: any) {
        super();
        if (jsonSerializedObject) {
          this.id = Guid.parseOrEmpty(jsonSerializedObject.id);
          this.fileName = jsonSerializedObject.fileName;
          this.fileType = EnumFileType.getByValue(jsonSerializedObject.fileType, this.fileType);
          this.fileContentsBase64 = jsonSerializedObject.fileContentsBase64;
        }

    }

    public toJsonSerializedObject(): any {
        const toRet = {} as any;
        toRet.id = this.id.toString();
        toRet.fileName = this.fileName;
        toRet.fileType = this.fileType.value;
        toRet.fileContentsBase64 = this.fileContentsBase64;
        return toRet;
    }

    public toProto(): any {
      return this.toJsonSerializedObject();
    }

    public toBinary(): Uint8Array {
      return new TextEncoder().encode(JSON.stringify(this.toJsonSerializedObject()));
    }

    public validationRules: ValidationRule = [
            {field: "id", rule: (v: any) => !v.isEmpty() || "FileBase64.Id cannot be empty"},
            {field: "fileName", rule: (v: any) => v == null || v.length !== 0 || "FileName cannot be empty"},
            {field: "fileName", rule: (v: any) => v == null || v.length <= 1000 || "FileName has too many characters (1000)"},
    ];
}


export class FileService extends ServiceBase {

  public async getFileBase64(tenantId: Guid, id: Guid, opts?: {requestTimeoutMs?: number, sessionToken?: string}): Promise<FileBase64 | null> {
    const req = {
    tenantId:tenantId.toString(),
    id:id.toString(),
    };
    const extractor = (response:any) => response.file == null ? null : new FileBase64(response.file);;
    return this.makeJsonRequest("file/v1/getFileBase64", req, false, extractor, opts);
  };

  public async saveFileBase64(tenantId: Guid, file: FileBase64, resizeMaxFileSizeBytes: number | null, opts?: {requestTimeoutMs?: number, sessionToken?: string}): Promise<void> {
    const req = {
    tenantId:tenantId.toString(),
    file:file.toJsonSerializedObject(),
    resizeMaxFileSizeBytes:resizeMaxFileSizeBytes == null ? null : resizeMaxFileSizeBytes,
    };
    const extractor = null;
    return this.makeJsonRequest("file/v1/saveFileBase64", req, true, extractor, opts);
  };

  public async getFilesBase64(tenantId: Guid, ids: readonly Guid[], opts?: {requestTimeoutMs?: number, sessionToken?: string}): Promise<FileBase64[]> {
    const req = {
    tenantId:tenantId.toString(),
    ids:ids.map(v => v.toString()),
    };
    const extractor = (response:any) => response.files.map((v: any) => new FileBase64(v));;
    return this.makeJsonRequest("file/v1/getFilesBase64", req, false, extractor, opts);
  };
}

export const fileService = new FileService();